// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + ".js";
};